export function sr(seed) {
  let s = seed;
  return () => {
    s = (s * 16807 + 1) % 2147483647;
    return s / 2147483647;
  };
}
